import { useState } from 'react';
import { ContentModalContentType } from 'domains/content/types';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import InfoSnackbar from 'domains/core/components/Snackbars/InfoSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import ConfirmationDialog from 'domains/core/components/ConfirmationDialog';
import { Folder } from 'models/types';
import useUnarchiveTableItem from 'hooks/useUnarchiveTableItem';

type Props = {
    activeItem: ContentModalContentType | Folder;
    handleModalClose: () => void;
    isOpen: boolean;
    refetchTableData: () => void;
    resetActiveItem: () => void;
};

const UnarchiveTableItemModal = ({
    activeItem,
    handleModalClose,
    isOpen,
    refetchTableData,
    resetActiveItem,
}: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { getUnarchiveItemFunction, isLoading, isSuccess } = useUnarchiveTableItem({
        activeItem,
        refetchTableData,
        resetActiveItem,
        setErrorMessage,
        setSuccessMessage,
    });

    const handleUnarchive = () => {
        const unarchiveItem = getUnarchiveItemFunction();
        unarchiveItem();
        handleModalClose();
    };

    const onCancel = () => {
        handleModalClose();
        resetActiveItem();
    };

    const infoMessage = `Unarchiving "${activeItem?.name}"`;
    const contentText = `You are about to unarchive "${activeItem?.name}." This will move the item back to the main list.`;
    const title = `Unarchive ${activeItem?.type}`;

    return (
        <>
            {errorMessage && <ErrorSnackbar errorMessage={errorMessage} />}
            {isLoading && <InfoSnackbar successMessage={infoMessage} />}
            {isSuccess && <SuccessSnackbar successMessage={successMessage} />}
            <ConfirmationDialog
                dialogProps={{
                    confirmButtonText: 'Unarchive',
                    contentText,
                    title,
                }}
                onCancel={onCancel}
                onConfirm={handleUnarchive}
                onModalClose={handleModalClose}
                open={isOpen}
            />
        </>
    );
};

export default UnarchiveTableItemModal;
